import { render, staticRenderFns } from "./EmployeeEducationDetail.vue?vue&type=template&id=3efc746f&scoped=true&"
import script from "./EmployeeEducationDetail.vue?vue&type=script&lang=js&"
export * from "./EmployeeEducationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efc746f",
  null
  
)

export default component.exports